import { buildReviewsSchema, RawReviews, OrgInfo } from "./buildReviewsSchema";

type Props = {
  reviews: RawReviews;
  dates?: Parameters<typeof buildReviewsSchema>[0]["dates"];
  returnOnlyObject?: boolean;
};

export default function ReviewsJsonLd({
  reviews,
  dates,
}: Props) {
  const org = {
    id: "https://youngsparrows.com/",
    name: "Young Sparrows",
    url: "https://youngsparrows.com/",
    logo: "https://youngsparrows.com/logo.webp"
  };
  const schema = buildReviewsSchema({ org, reviews, dates });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
